import { buttonClass } from "@/components/common/controls";
import { EditIcon } from "@/components/icons";
import { SectionCard } from "@/components/posting/parts";
import { actionProps } from "@/lib/controlAnalytics";
import { pasteBoxClass } from "./styles";

function foundLine(found: number): string {
    if (found === 0) return "We found no skill we know.";
    return `${found} ${found === 1 ? "keyword" : "keywords"} found. Edit to check a new job.`;
}

/** The job: a box to paste it in, or once checked, one line with an Edit button. */
export default function JobBox({
    job,
    onChange,
    found,
    onEdit,
    editing,
}: {
    job: string;
    onChange: (text: string) => void;
    /** The keywords a check found, folding the box; null while it is open. */
    found: number | null;
    onEdit: () => void;
    /** Opened by the Edit button, so the box takes the cursor. */
    editing: boolean;
}) {
    if (found !== null)
        return (
            <SectionCard>
                <div className="flex items-center justify-between gap-3">
                    <div className="flex min-w-0 flex-col text-ui text-fg-muted">
                        <span className="font-display text-subhead font-bold tracking-[-0.01em] text-fg">
                            The job
                        </span>
                        <span className="[text-wrap:pretty]">{foundLine(found)}</span>
                    </div>
                    <button
                        {...actionProps("resume_field_edited", {
                            source: "ResumeCheck",
                            field: "job",
                        })}
                        type="button"
                        aria-label="Edit the job"
                        onClick={onEdit}
                        className={buttonClass("secondary", "md")}
                    >
                        <EditIcon className="size-3.5" />
                        Edit
                    </button>
                </div>
            </SectionCard>
        );
    return (
        <SectionCard className="gap-3.5" title="The job" caption="The whole description is best.">
            <textarea
                {...actionProps("resume_paste_edited", { source: "ResumeCheck", field: "job" })}
                autoFocus={editing}
                aria-label="The job description"
                placeholder="Paste the job description, the whole text"
                value={job}
                onChange={(event) => onChange(event.target.value)}
                className={pasteBoxClass(job !== "", "h-[170px] max-[760px]:h-[130px]")}
            />
        </SectionCard>
    );
}
